// extracted by mini-css-extract-plugin
export default {"scrollContainer":"ListaLinksScroleable_scrollContainer__2-K3Y","listItem":"ListaLinksScroleable_listItem__jpzCp"};